export const WATCHLIST_DEFAULT_TITLE = 'My Watchlist';
export const WATCHLIST_LIMIT = 100;
export const WATCHLIST_TITLE_MAX_LENGTH = 25;
export const WATCHLIST_TITLE_MIN_LENGTH = 3;
